export type PayrollFrequency = "weekly" | "biweekly" | "semimonthly" | "monthly" | "custom";

type ExistingPayrollPeriod = {
  periodEnd: string;
  runType: string;
  status: string;
};

const isoDate = (date: Date) => date.toISOString().slice(0, 10);
const parseIsoDate = (value: string) => new Date(`${value}T12:00:00Z`);
const addDays = (value: string, days: number) => {
  const date = parseIsoDate(value);
  date.setUTCDate(date.getUTCDate() + days);
  return isoDate(date);
};

const periodEnd = (start: string, frequency: PayrollFrequency) => {
  if (frequency === "weekly") return addDays(start, 6);
  if (frequency === "biweekly") return addDays(start, 13);
  const date = parseIsoDate(start);
  if (frequency === "semimonthly" && date.getUTCDate() <= 15) {
    date.setUTCDate(15);
    return isoDate(date);
  }
  if (frequency === "semimonthly" || frequency === "monthly") {
    date.setUTCMonth(date.getUTCMonth() + 1, 0);
    return isoDate(date);
  }
  return start;
};

const followingFriday = (end: string) => {
  let date = addDays(end, 1);
  while (parseIsoDate(date).getUTCDay() !== 5) date = addDays(date, 1);
  return date;
};

export function suggestNextPayrollPeriod(
  runs: ExistingPayrollPeriod[],
  frequency: PayrollFrequency,
  today: string,
) {
  const latestEnd = runs
    .filter((run) => run.runType === "regular" && run.status !== "voided")
    .map((run) => run.periodEnd)
    .sort()
    .at(-1);
  let start: string;
  if (latestEnd) start = addDays(latestEnd, 1);
  else {
    const current = parseIsoDate(today);
    const daysSinceMonday = (current.getUTCDay() + 6) % 7;
    start = addDays(today, -daysSinceMonday);
  }
  const end = periodEnd(start, frequency);
  return { periodStart: start, periodEnd: end, payDate: followingFriday(end) };
}
